import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getFilteredProjectSubprojects } from '@/features/projects/shared/api/get-filtered-project-subprojects';
import { useSubprojectHubFilterStore } from '@/features/projects/subprojects-hub/hooks/subprojects-filter';
import { ProjectWithContractors } from '@/shared/types/api';

type QueryResult = ProjectWithContractors[];

type Props = {
  projectId: number;
  queryProps?: UseQueryOptions<QueryResult, unknown, QueryResult>;
};

export function getFilteredSubprojectsQueryKey({
  projectId,
}: {
  projectId: number;
}) {
  return ['projectSubprojects', 'filtered', projectId];
}

export const useProjectSubprojectsFiltered = ({
  projectId,
  queryProps,
}: Props) => {
  const {
    statuses,
    partnerIds,
    notificationStatuses,
    lastEntry,
    searchQuery,
    fromDate,
    toDate,
  } = useSubprojectHubFilterStore();

  const filters = {
    statuses,
    partnerIds,
    notificationStatuses,
    lastEntry,
    searchQuery,
    dateFrom: fromDate,
    dateTo: toDate,
  };

  return useQuery({
    ...queryProps,
    queryKey: [
      ...getFilteredSubprojectsQueryKey({
        projectId,
      }),
      filters,
    ],
    queryFn: async () => {
      return getFilteredProjectSubprojects({ projectId, filters });
    },
  });
};
